export const ALL_ELD_VT = "ALL_ELD_VT";
export const ELD_VT_TEST = "ELD_VT_TEST";
export const ELD_VT_DRIVERS = "ELD_VT_DRIVERS";
export const ELD_VT_VEHICLES = "ELD_VT_VEHICLES";
